import { styled } from '@linaria/react';

import { fonts, semantic, size, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
`;

export const MethodHeading = styled.h4`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const MethodRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
`;

export const MethodOption = styled.label`
  display: flex;
  align-items: center;
  gap: ${space['space-300']};
  padding: ${space['space-400']};
  border: 1px solid ${semantic.border.default};
  border-radius: ${size.radius['radius-sm']};
  background: ${semantic.bg.canvas};
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};

  &[data-selected='true'] {
    border-color: ${semantic.border.selected};
  }

  &[data-disabled='true'] {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const MethodIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${semantic.text.primary};
  flex-shrink: 0;
`;

export const MethodLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${space['space-200']};
  flex: 1;
`;

export const MethodPrice = styled.span`
  margin-left: auto;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
`;

export const Radio = styled.input`
  appearance: none;
  margin: 0;
  width: 16px;
  height: 16px;
  border: 1px solid ${semantic.border.default};
  border-radius: 50%;
  cursor: inherit;
  background: ${semantic.bg.canvas};
  flex-shrink: 0;

  &:checked {
    border-color: ${semantic.border.selected};
    background: ${semantic.border.selected};
    box-shadow: inset 0 0 0 3px ${semantic.text.inverse};
  }
`;

export const MessageBox = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
`;

export const CostRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space['space-300']} ${space['space-400']};
  background: ${semantic.bg.surfaceSubtle};
  border-radius: ${size.radius['radius-xs']};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.primary};
`;
